import React, { useEffect, useRef } from 'react';

import DealDetail from './DealDetail';
import ExpiryQuotationBanner from './ExpiryQuotationBanner';
import RefusedBanner from './RefusedBanner';
import { useIsSmall } from '../../../../Components/Context/Hooks/mediaQueries';
import Box from '../../../../Components/UI/Box';
import { QUOTATION_STATUS } from '../../../../Types/quotation';
import { assertErrors } from '../../../../Utils/errors';
import { DealContext } from '../../Context';
import { DealsHeader } from '../../Header';
import LoadingSkeleton from '../../LoadingSkeleton';
import Main from '../../Main';
import MainBody from '../../Main/MainBody';
import { DealsNavigation } from '../../Navigation';
import Translations from '../../Translations';
import useQuotation from '../../useQuotation';

interface DealsProps {
  quotationId?: string;
  themeLoading: boolean;
}

const Deals: React.FC<DealsProps> = ({ quotationId, themeLoading }) => {
  const language = useRef<string | null>(null);
  const isSmall = useIsSmall();

  const { loading, deal, quotation, pdf, error } = useQuotation(quotationId);
  const quotationIsRefused = quotation?.status === QUOTATION_STATUS.REFUSED;
  if (deal || !loading) {
    language.current = deal?.client.language || navigator.language.split('-')[0];
  }

  assertErrors(error);

  useEffect(() => {
    if (!deal) {
      return;
    }

    document.title = `CloudSign - ${deal.department.name}`;
  }, [deal]);

  return (
    <Translations
      loader={<LoadingSkeleton style={isSmall ? 'mobile' : 'collapsed'} />}
      loading={(themeLoading || !deal) && !error}
      language={language.current}
    >
      <DealContext.Provider
        value={{
          deal,
          quotation,
          pdf,
        }}
      >
        <Main>
          <DealsNavigation />
          <Box flex={1} display="flex" flexDirection="column" overflow="auto">
            <DealsHeader />
            {!!quotation && <ExpiryQuotationBanner />}
            {quotationIsRefused && <RefusedBanner />}
            <MainBody language={language.current}>
              <DealDetail loading={loading} defaultLanguage={language.current} />
            </MainBody>
          </Box>
        </Main>
      </DealContext.Provider>
    </Translations>
  );
};

export default Deals;
